import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

//*****PAGES */
import { HomeComponent} from './home/home.component';
//import { HomeHeaderComponent } from './home-header/home-header.component';
//import { FooterComponent } from './footer/footer.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { FaqComponent } from './faq/faq.component';
import { ShippingAddressComponent } from './shipping-address/shipping-address.component';
import { MyAccountComponent } from './my-account/my-account.component';
import { MyPackagesComponent } from './my-packages/my-packages.component';
import { AddressComponent } from './address/address.component';
import { RateComponent } from './rate/rate.component';
import { ServiceComponent } from './service/service.component';
import { SmartshipPayComponent } from './smartship-pay/smartship-pay.component';
import { AccountVerifyComponent } from './account-verify/account-verify.component';
import { AddCardComponent } from './add-card/add-card.component';
import { TexDetailComponent } from './tex-detail/tex-detail.component';
import { AddinvoiceComponent } from './addinvoice/addinvoice.component'
//import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { PageNotFoundComponent }    from './not-found.component';
import { RequestDeliveryComponent } from './request-delivery/request-delivery.component';
import { AuthorizedCollectComponent } from './authorized-collect/authorized-collect.component';
import { PrePullPackageComponent } from './pre-pull-package/pre-pull-package.component';


//*****PROVIDER */
import { CanDeactivateGuard }       from './can-deactivate-guard.service';
import { AuthGuard }                from './auth-guard.service';
import { SelectivePreloadingStrategy } from './selective-preloading-strategy';

const appRoutes: Routes = [
  { path: '',   redirectTo: '/home', pathMatch: 'full' },
  { path: 'home',component: HomeComponent },
  { path: 'reset-password/:token',component: HomeComponent },
  { path: 'about', component: AboutUsComponent },
  { path: 'terms', component: AboutUsComponent },
  { path: 'privacy', component: AboutUsComponent },
  { path: 'contact', component: ContactUsComponent },
  { path: 'faq', component: FaqComponent },
  { path: 'shippingAdd', component: ShippingAddressComponent },
  { path: 'myaccount', component: MyAccountComponent, canActivate: [AuthGuard] },
  { path: 'mypackage', component: MyPackagesComponent, canActivate: [AuthGuard] },
  { path: 'requestDelivery', component: RequestDeliveryComponent, canActivate: [AuthGuard] },
  { path: 'authorizedCollect', component: AuthorizedCollectComponent, canActivate: [AuthGuard] },
  { path: 'prePullPackage', component: PrePullPackageComponent, canActivate: [AuthGuard] },
  { path: 'address', component: AddressComponent, canActivate: [AuthGuard] },
  { path: 'rate', component: RateComponent },
  { path: 'service', component: ServiceComponent },
  { path: 'smartship', component: SmartshipPayComponent },
  { path: 'account-verify/:token', component: AccountVerifyComponent },
  { path: 'addcard/:warehouseId', component: AddCardComponent },
  { path: 'texdetail/:warehouseId', component: TexDetailComponent },
  { path: 'addinvoive', component: AddinvoiceComponent },
  //{ path: 'reset-password/:token', component: ResetPasswordComponent },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes,
      {
        enableTracing: false, // <-- debugging purposes only
        preloadingStrategy: SelectivePreloadingStrategy,
      }
    )
  ],
  exports: [
    RouterModule
  ],
  providers: [
    CanDeactivateGuard,
    SelectivePreloadingStrategy
  ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts